<template>
  <ModalForm
    action="feedback/send"
    :form-config="props.formInfo"
    :submit-label="props.button"
    @submit:success="onSuccessSubmit"
    @submit:error="onErrorSubmit"
  >
    <template #personalDataAgreement="{ field, input }">
      <FormField :field="field">
        <PersonalDataAgreement
          :value="field.value"
          :error="field.error"
          @input="input"
          @link-click="onLinkClick"
        ></PersonalDataAgreement>
      </FormField>
    </template>
  </ModalForm>
</template>

<script>
import { mapActions } from 'vuex'
import FormField from '@shared/ui/public/forms/components/FormField.vue'
import ModalForm from '@shared/ui/public/forms/ModalForm.vue'
import PersonalDataAgreement from '@shared/ui/public/forms/fields/PersonalDataAgreement.vue'

export default {
  name: 'feedback',
  props: ['props'],
  components: {
    ModalForm,
    FormField,
    PersonalDataAgreement,
  },
  methods: {
    ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),

    onLinkClick(event) {
      event.preventDefault()
      this.modalClose()
    },
    onSuccessSubmit() {
      this.modalClose()

      this.modalType_successOpen({
        title: this.$root.staticText.modal.successTitleFeedback,
        text: this.$root.staticText.modal.successTextFeedback,
        class: '_small',
      })
    },
    onErrorSubmit() {
      this.modalClose()

      this.modalType_errorOpen({
        title: this.$root.staticText.modal.errorTitle,
        text: this.$root.staticText.modal.errorText,
        class: '_small',
      })
    },
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/collab.vue